import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  breadcrumbs: {
    '& .MuiBreadcrumbs-li:last-child .MuiTypography-root': {
      maxWidth: '300px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    '& .MuiBreadcrumbs-li .MuiTypography-root': {
      '& .MuiSvgIcon-root': {
        marginRight: '4px'
      }
    }
  }
});
export default useStyles;